import styles from "../getstarted/Getstarted.module.css";
import {Landing1,Landing2} from "../../controller/Images";
import Buttons from "../../components/buttons/Buttons";
import { useNavigate } from "react-router-dom";

function Getstarted() {
  const navigate = useNavigate();
  return (
    <div className={styles.getstarted_section}>
      {/* <video autoPlay loop muted className={styles.custom_video}>
        <source src={Video} type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}
      <img
        src={Landing1}
        // src={Landing2}
        alt="Get Started Background"
        className={styles.custom_media}
      />
      <div
        className={`d-flex align-items-center justify-content-start text-start ${styles.maincontainer}`}
      >
        <div className={`${styles.container}`}>
          <h5 className="d-flex justify-content-start mb-3">
            Intelligent Technology. Real Business Impact.
          </h5>
          <p className="text-start">
            Strategic technology design and execution for resilient,
            future-ready organizations. 
          </p>
          <div className={`${styles.custom_btn}`}>
            <Buttons text="Talk To Us" onClick={() => navigate("/lets-talk")} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Getstarted;
